import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { TattooChoices } from '@prisma/client';
import {
  Appointment,
  GeneralRequest,
  LoadedUser,
  ModalData,
} from '../../interfaces';
import { createModalData } from '../../utils/modal/requestModal';
import { getCustomerNameFromAppointment } from '../../utils/global/helper';
import RequestImage from '../appointments/RequestImage';
import useUser from '../../hooks/global/useUser';

interface Props {
  appointment: Appointment | GeneralRequest;
  handleClick: (
    newModalData: ModalData,
    appointment: Appointment | GeneralRequest,
  ) => void;
  sizeOptions: TattooChoices[] | undefined;
  isUnread?: boolean;
}

export default function RequestCard({
  appointment,
  handleClick,
  sizeOptions,
  isUnread,
}: Props) {
  const { user: loadedUser } = useUser<LoadedUser>();
  const navigate = useNavigate();
  const navigateToCustomer = (customerId: string) => {
    navigate(`/customers/${customerId}`);
  };

  const newModalData = createModalData({
    appointment,
    sizeOptions,
    navigateToCustomer,
    allBusinesses: loadedUser?.allBusinesses,
    employeesToBusiness: loadedUser?.business?.employees,
  });

  return (
    <Box
      onClick={() => handleClick(newModalData, appointment)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 5,
        maxWidth: '140px',
      }}>
      <RequestImage
        image={appointment.refImgsId?.[0]}
        isUnread={isUnread}
        width="140px"
      />
      <div style={{ paddingTop: 10 }}>
        <Typography variant="h5" className="ellipsis">
          {(appointment as Appointment).appointmentId
            ? `${(appointment as Appointment).employee.firstName} ${
                (appointment as Appointment).employee.lastName
              }`
            : 'Any artist'}
        </Typography>
        <Typography variant="body2" className="ellipsis">
          {getCustomerNameFromAppointment(appointment)}
        </Typography>
      </div>
    </Box>
  );
}
